module.exports = __webpack_public_path__ + "static/media/image.7ce0a355.png";